import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { LoyaltyCurrencyIcon, useLoyaltyCurrencyFormat } from '@ocx/feat-loyalty-currency';
import { Paper, SizingMultiplier, Typography } from '@ocx/ui';

import { totalPointsEarnedMessages } from './total-points-earned.messages';

export type TotalPointsEarnedSectionProps = {
  pointsEarned: number;
};

export const TotalPointsEarnedSection = ({ pointsEarned }: TotalPointsEarnedSectionProps) => {
  const formatLoyaltyCurrency = useLoyaltyCurrencyFormat();

  const formattedValue = formatLoyaltyCurrency(pointsEarned);

  return (
    <Box px={SizingMultiplier.sm} pt={SizingMultiplier.sm}>
      <Paper p={0} sx={{ position: 'relative', overflow: 'hidden' }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          py={SizingMultiplier.md}
          px={SizingMultiplier.md}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={SizingMultiplier.sm}>
            <LoyaltyCurrencyIcon variant="multiple" size="large" />
            <Typography component="p" variant="h2" sx={{ m: 0, textTransform: 'none' }}>
              {formattedValue}
            </Typography>
          </Box>
          <Typography component="p" variant="body2" align="center" sx={{ mt: SizingMultiplier.xs }}>
            <FormattedMessage {...totalPointsEarnedMessages['total-points-earned:subtitle']} />
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};
